import { render, staticRenderFns } from "./contacts-tab.vue?vue&type=template&id=3d82e198"
import script from "./contacts-tab.vue?vue&type=script&lang=js"
export * from "./contacts-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports